export const SPORTS = [
  { k: "futebol", label: "Futebol de campo", icon: "⚽" },
  { k: "society", label: "Society", icon: "⚽" },
  { k: "futsal", label: "Futsal", icon: "⚽" },
  { k: "volei", label: "Vôlei", icon: "🏐" },
  { k: "basquete", label: "Basquete", icon: "🏀" },
  { k: "beach_tennis", label: "Beach tennis", icon: "🎾" },
  { k: "corrida", label: "Corrida", icon: "🏃" },
  { k: "outro", label: "Outro", icon: "🏅" },
];

export const LEVELS = [
  { k: "resenha", label: "Resenha" },
  { k: "intermediario", label: "Intermediário" },
  { k: "competitivo", label: "Competitivo" },
];

export const sportOf = (k) => SPORTS.find((s) => s.k === k) || SPORTS[SPORTS.length - 1];
export const levelLabel = (k) => LEVELS.find((l) => l.k === k)?.label || k;
